export const EnumToList = (enumType) => {
    let list = [];

    for (const key in enumType) {
        let item = { value: enumType[key], label: enumType[key]}

        if (enumType.hasOwnProperty(key) && list.indexOf(item) === -1) {
            list.push(item)
        }
    }

    return list;
}